import { axios, getConfigs } from './common';

export default class TripService {
  async getList(params) {
    return new Promise((resolve, reject) => {
      let url = `/r2api/trip/`;

      const options = {};
      const configs = getConfigs('get', 'application/json', url, options);

      configs.params = params;

      axios(configs, resolve, reject);
    });
  }
}
